module.exports = __webpack_public_path__ + "static/media/Logo_SAS-LOG-03.9ef561bd.png";